var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';
var Forward = /** @class */ (function () {
    function Forward(InboundNumbersService, $stateParams, $state, Toast, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }
    Forward.prototype.$onInit = function () {
        this.settings = angular.copy(this.settings);
    };
    Forward.prototype.save = function () {
        var _this = this;
        var updatedSettings = __assign({}, this.settings, { checked: true });
        this.settings = updatedSettings;
        this.InboundNumbersService.setNumberSettings({ id: this.msisdnid }, { forwardCallConfiguration: this.settings }, function () {
            _this.hide();
            _this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(_this.router);
        });
    };
    Forward.$inject = ['InboundNumbersService', '$stateParams', '$state', 'Toast', 'Router'];
    return Forward;
}());
export default {
    controller: Forward,
    template: require('./phone.details.forward.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
